<template>
  <div>
    <el-form label-position="top" size="small">
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item :label="$t('collectionCenter.Barcode')">
            <el-input
              v-model="queryForm.params.waybillNumbers"
              :placeholder="$t('collectionCenter.max2000Line')"
              :rows="5"
              type="textarea"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--定责时间-->
          <el-form-item :label="$t('fixDutyFine.DefiniteTime')">
            <el-date-picker
              v-model="timeValue"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('operationCenter.endDate')"
              :format="$i18n.locale === 'zh' ? zhDate : ptDate"
              :start-placeholder="$t('operationCenter.startDate')"
              range-separator="~"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!--责任方-->
          <el-form-item :label="$t('fixDutyFine.ResponsibleParty')">
            <el-select
              v-model="queryForm.params.partys"
              :placeholder="$t('collectionCenter.tudo')"
              clearable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in partResponsibleList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!--责任网点-->
          <el-form-item :label="$t('fixDutyFine.ResponsibleBranch')">
            <el-select
              v-model="queryForm.params.sites"
              :placeholder="$t('collectionCenter.tudo')"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in siteIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div style="margin-top: 27px">
            <el-button
              size="small" type="primary" @click="enterSearch"
            >{{ $t('collectionCenter.search') }}
            </el-button>
            <el-button
              plain size="small" @click="resetSearch"
            >{{ $t('collectionCenter.reset') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-table
        :data="totalTableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black', textAlign: 'center' }"
        border
        @cell-click="handleCellClick"
      >
        <el-table-column
          v-for="(item, index) in tableColumn1"
          :key="index"
          :align="item.align"
          :class-name="item.className"
          :label="item.label"
          :prop="item.prop"
        >
          <template slot-scope="scope">
            <div style="color: #f16283; cursor: pointer">
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-bottom: 10px">
      <div>
        {{ $t('navbar.gong') }} <span style="color: #409eff">{{ total }}</span>
        {{ $t('fixDutyFine.Item') }}
        <!--导出-->
        <el-button
          size="small" style="float: right" type="primary"
          @click="exportExcel"
        >{{ $t('collectionCenter.export') }}
        </el-button>
      </div>
    </div>
    <div>
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black', textAlign: 'center' }"
        border
      >
        <el-table-column
          v-for="(item, index) in tableColumn"
          :key="index"
          :align="item.align"
          :class-name="item.className"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
        />
      </el-table>
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 50, 100, 200, 400]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 20px 0; text-align: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import { goResourceTaskList } from '@/utils/goExportList';
import {
  getAllCottageList,
  getLostPackagePageApi,
  getLostPackageTrackingTotal,
  lostPackageTrackingDetailsExport
} from '@/api/definiteResponsibilityAndPenalty';

export default {
  name: 'LMLiabilityForLosses',
  data() {
    return {
      timeValue: [],
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          waybillNumbers: '',
          numberType: 1,
          partys: [],
          sites: []
        }
      },
      siteIdList: [],
      totalTableData: [],
      tableColumn1: [],
      tableColumn: [
        // 条形码
        {
          label: this.$t('collectionCenter.Barcode'),
          prop: 'scanNumber',
          align: 'center',
          width: 200
        },
        // 定责时间
        {
          label: this.$t('fixDutyFine.DefiniteTime'),
          prop: 'dutyTime',
          align: 'center',
          width: 180
        },
        // 定责类型
        {
          label: this.$t('fixDutyFine.DefiniteType'),
          prop: 'dutyTypeName',
          align: 'center',
          width: 180
        },
        // 责任方
        {
          label: this.$t('fixDutyFine.ResponsibleParty'),
          prop: 'responsibilityPartyName',
          align: 'center',
          width: 180
        },
        // 责任网点
        {
          label: this.$t('fixDutyFine.ResponsibleBranch'),
          prop: 'responsibilitySiteName',
          align: 'center',
          width: 180
        },
        // 责任人
        {
          label: this.$t('GlobalSetObj.PersonInCharge'),
          prop: 'responsibilityUserName',
          align: 'center',
          width: 180
        },
        // 预计扣罚金额
        {
          label: this.$t('fixDutyFine.EstimatedPenaltyAmount'),
          prop: 'totalValue',
          align: 'center',
          width: 180
        }
      ],
      tableData: [],
      total: 0,
      partResponsibleList: [
        // { label: '商家', value: 'MERCHANT' },
        { label: this.$t('collectionCenter.LanShouSite'), value: 'COLLECTION_SITE' },
        { label: this.$t('collectionCenter.driver1'), value: 'DRIVER' },
        { label: 'SHEIN', value: 'SHEIN' }
        // { label: '未知', value: 'UNKNOWN' }
      ],
      toSiteId: null,
      notSite: false
    };
  },
  created() {
    // 初始化时间
    this.initTime();
    // 查询列表
    this.getSearch();
    // 获取所有网点
    this.getBranchList();
  },
  methods: {
    handleCellClick(row, column) {
      console.log(row, 'rowrowrow', column);
      this.queryForm.pageNumber = 1;
      if (column.label === '无责任网点' || column.label === 'Sem Ponto de Responsabilidade') {
        this.notSite = true;
      } else if (column.label === '总计' || column.label === 'Total') {
        this.notSite = false;
      } else {
        this.notSite = false;
      }
      const property = column.property.split(',');
      if (property[1] !== 'null') {
        this.toSiteId = Number(property[1]);
      } else {
        this.toSiteId = null;
      }
      console.log(this.toSiteId, 'this.toSiteId');
      const queryParam = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: this.queryParam()
      };
      if (queryParam.params.scanNumbers.length > 2000) {
        this.$message.warning(this.$t('orderCenterCont.queried2000pieces'));
        return;
      }
      // 分页
      getLostPackagePageApi(queryParam).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.toSiteId = null;
      this.getSearch();
    },
    // 导出
    exportExcel() {
      console.log(11212);
      let exportParam = {};
      if (this.timeValue && this.timeValue.length > 0) {
        exportParam = this.queryParam();
        if (exportParam.scanNumbers.length > 2000) {
          this.$message.warning(this.$t('orderCenterCont.queried2000pieces'));
          return;
        }
      } else {
        exportParam = this.queryParam();
        if (!this.queryForm.params.waybillNumbers) {
          this.$message.error(this.$t('fixDutyFine.selectTimeRange'));
          return;
        }
      }
      if (this.tableData.length > 0) {
        lostPackageTrackingDetailsExport(exportParam).then((res) => {
          if (res.code === 200) {
            goResourceTaskList();
          }
        });
      } else {
        this.$message.warning(this.$t('collectionCenter.noDataExport'));
      }
    },
    // 查询条件整理
    queryParam() {
      const params = {
        partys: this.queryForm.params.partys,
        scanNumbers: [],
        sites: this.queryForm.params.sites,
        startTime: '',
        endTime: '',
        noSite: false
      };
      if (this.toSiteId) {
        params.sites = [this.toSiteId];
      }
      if (this.notSite) {
        params.noSite = true;
      }
      if (this.queryForm.params.waybillNumbers) {
        const num = this.queryForm.params.waybillNumbers.split(/([\n\r])/);
        num.map((item) => {
          const reg = /\s/g;
          const a = item.replace(reg, '');
          const b = a.trim();
          if (b) {
            if (this.queryForm.params.numberType === 1) {
              params.scanNumbers.push(b);
            } else {
              params.scanNumbers.push(b);
            }
          }
        });
      }
      if (this.timeValue && this.timeValue.length > 1) {
        params.startTime = this.timeValue[0];
        params.endTime = this.timeValue[1];
      }
      return params;
    },
    // 查询
    getSearch() {
      const queryParam = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {}
      };
      if (this.timeValue && this.timeValue.length > 0) {
        queryParam.params = this.queryParam();
        if (queryParam.params.scanNumbers.length > 2000) {
          this.$message.warning(this.$t('orderCenterCont.queried2000pieces'));
          return;
        }
      } else {
        // const data = this.queryParam();
        queryParam.params = this.queryParam();
        if (!this.queryForm.params.waybillNumbers) {
          this.$message.error(this.$t('fixDutyFine.selectTimeRange'));
          return;
        }
      }
      // 分页
      getLostPackagePageApi(queryParam).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
      if (!this.queryForm.params.waybillNumbers) {
        // 统计
        getLostPackageTrackingTotal(queryParam.params).then((res) => {
          if (res.code === 200) {
            this.tableColumn1 = [];
            const val = {};
            this.totalTableData = [];
            res.data.forEach((item, index) => {
              let prop01 = '';
              if (item.siteName === '总计' || item.siteName === 'Total') {
                prop01 = 'orderCount' + ',' + 'Total';
              } else {
                prop01 = 'orderCount' + ',' + item.siteId;
              }
              const obj = {
                orderCount: item.orderCount,
                label: item.siteName,
                prop: prop01,
                align: 'center',
                className: 'primary'
              };
              this.tableColumn1.push(obj);
              val[prop01] = item.orderCount;
            });
            this.totalTableData.push(val);
            console.log(this.totalTableData, 'this.totalTableDatathis.totalTableData');
          }
        });
      }
    },
    // 重置
    resetSearch() {
      this.queryForm.pageNumber = 1;
      this.queryForm.params = {
        waybillNumbers: '',
        numberType: 1,
        partys: [],
        sites: []
      };
      this.toSiteId = null;
      this.notSite = false;
      this.initTime();
      this.getSearch();
    },
    // 初始化时间
    initTime() {
      const today = dayjs().format('YYYY-MM-DD');
      const oneWeekAgo = dayjs().subtract(2, 'day').format('YYYY-MM-DD');
      this.timeValue = [oneWeekAgo + ' 00:00:00', today + ' 23:59:59'];
    },
    // 查询所有网点
    getBranchList() {
      getAllCottageList().then((res) => {
        if (res.code === 200) {
          this.siteIdList = res.data;
        }
      });
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 翻页
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    }
  }
};
</script>

<style scoped>
.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0;
}
</style>
